import * as React from 'react'
import { useContext, useState } from 'react'
import { AppContext } from './appcontext'
import "../styles/diaper.css"



export function Patterns(props: {}) {

    var ctx = useContext(AppContext)

    return <div className="max-w-3xl m-auto landing p-4 ">

        <figure className=" shadow-lg mb-5 md:flex bg-slate-100 rounded-xl p-8 md:p-0 ">
            <div className="pt-6 md:p-8 text-center md:text-left space-y-4">
                <blockquote className="text-2xl font-normal">
                    <img className="w-24 float-left mr-3 rounded-lg " src={`/images/mt.png`}></img>
                    <p className="text-xl " ><em>"Yesterday is gone.  Tomorrow has not come.  We have only today.  Let us begin."</em>  - Saint Teresa of Calcutta</p>
                    <br/><div className="float-none">
                        <p className="mt-3">We are now able to offer printable patterns!  Once you have cut and assembled the four pieces of the diaper pattern and the two pieces of the liner pattern, I suggest you trace them onto either foam board or cardboard and cut it out.  The pattern is easier to trace onto the t-shirts if it is on something thicker and sturdier than paper.  There are three different sizes.  The size t-shirt you have will sometimes determine the size pattern you will use.</p>
                        <p className="mt-3">If you are not able to successfully print at home, I can mail a paper pattern to you!  Just send an e-mail with your mailing address to: <a href="mailto: DiapersforHaiti@outlook.com"> DiapersforHaiti@outlook.com</a>.</p>
                        <p className="mt-3">Thank you so much for your help and interest in this project!  May God bless you.</p>
                    </div>
                    </blockquote>
            </div>
        </figure>
            <div className="w-full flex justify-around">
                <a className="rounded-md shadow-lg  bg-blue-500 hover:shadow-blue-700 hover:bg-blue-700 hover:shadow-xl" href={`/patterns/large.pdf`}>
                    <div>
                        <img className="w-20 m-4" src={`/images/diaper_large.png`} />
                        <div className="text-white text-center">Large</div>
                    </div>
                </a>
                <a className="rounded-md shadow-lg  bg-blue-500 hover:shadow-blue-700 hover:bg-blue-700 hover:shadow-xl" href={`/patterns/medium.pdf`}>
                    <div>
                        <img  className="w-20 m-4" src={`/images/diaper_large.png`} />
                        <div className="text-white text-center">Medium</div>
                    </div>
                </a>
                <a className="rounded-md shadow-lg  bg-blue-500 hover:shadow-blue-700 hover:bg-blue-700 hover:shadow-xl" href={`/patterns/small.pdf`}>
                    <div>
                        <img  className="w-20 m-4" src={`/images/diaper_large.png`} />
                        <div className="text-white text-center">Small</div>
                    </div>
                </a>
            </div>
    </div>
}